export const ADD_INCOME_DATA = "ADD_INCOME_DATA";
export const ADD_ALL_INCOME_DATA = "ADD_ALL_INCOME_DATA";
export const ADD_INCOME_COUNT = "ADD_INCOME_COUNT";
export const ADD_INCOME_TOTAL = "ADD_INCOME_TOTAL";
export const SET_PAN_LIST = "SET_PAN_LIST";
export const IS_EARNING = "IS_EARNING";
export const RESET_INCOME = "RESET_INCOME";
export const SET_DATE_LIST = "SET_DATE_LIST";

export const addIncomeInfo = (data) => {
  return {
    type: ADD_INCOME_DATA,
    data,
  };
};
export const setDateList = (data) => {
  return {
    type: SET_DATE_LIST,
    data,
  };
};

export const setEarning = (data) => {
  return {
    type: IS_EARNING,
    data,
  };
};
export const addPanList = (data) => {
  return {
    type: SET_PAN_LIST,
    data,
  };
};
export const resetIncome = (data) => {
  return {
    type: RESET_INCOME,
    data,
  };
};

export const addIncomeCount = (data) => {
  return {
    type: ADD_INCOME_COUNT,
    data,
  };
};
export const addIncomeTotal = (data) => {
  return {
    type: ADD_INCOME_TOTAL,
    data,
  };
};

export const addAllIncomeInfo = (data) => {
  return {
    type: ADD_ALL_INCOME_DATA,
    data,
  };
};

